<template>
  <div>
    <user-token-site-name :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="bulk-detail-modal" :class="[member_modal ? 'open' : '']">
      <div v-if="member_modal && !loading" class="member-edit-wrap">
        <div class="member-edit-title">
          メンバー編集
          <div class="flex-space"></div>
          <el-dropdown trigger="click" placement="bottom-end" size="small" v-if="!member.super_admin_member">
            <el-button type="info" size="mini">
              アクション
              <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left:5px" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="color:#f56c6c" class="danger" icon="el-icon-takeaway-box" @click.native="deleteMember()">メンバーを削除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div style="min-width:20px"></div>
        </div>
        <div class="member-edit-body">
          <div class="setting-member-change">
            <div class="setting-member-image member">
              <el-tooltip content="写真を変更" placement="top">
                <div class="setting-member-icon" @click="img_upload = true">
                  <font-awesome-icon :icon="['fas', 'camera-alt']" />
                </div>
              </el-tooltip>
              <el-image :src="member.img_url" class="setting-member-profile">
                <div slot="error" class="setting-member-noimg">{{ member.person_name | firstLetter }}</div>
              </el-image>
            </div>
            <div style="display: flex; flex-flow:column; margin-left:20px; width:100%">
              <memberInput :value.sync="member.person_name" :super_admin_member="member.super_admin_member" :type="'name'" style="margin-bottom:5px" @editHandler="editHandler" />
              <div style="font-size:11px; color:#999; margin: 0 0 10px 15px">{{ member.email }}</div>
            </div>
          </div>
          <div class="member-edit-admin">
            <div class="member-edit-admin-description">
              <span style="font-weight:700; margin-bottom:5px; font-size:14px"> <span v-if="member.super_admin_member">スーパー</span>管理者 </span>
              <span style="font-size:10px; color:#666">管理者は全てのページの閲覧と編集権限が付与されます。</span>
            </div>
            <div class="flex-space"></div>
            <el-tooltip content="スーパー管理者は管理者権限をオフにすることができません" :disabled="!member.super_admin_member">
              <el-switch
                v-model="member.admin_member"
                active-color="#0095f6"
                :nactive-value="true"
                inactive-color="#ccc"
                :inactive-value="false"
                @change="switchAdmin()"
                :disabled="member.super_admin_member"
              ></el-switch>
            </el-tooltip>
            <div style="margin-left: 10px;">
              <span v-if="member.admin_member" style="font-weight:700; color:#0095f6">オン</span>
              <span v-else style="color:#ccc">オフ</span>
            </div>
          </div>
          <div class="bulk-detail-subtitle">アクセス・編集権限</div>
          <div class="bulk-detail-box" style="margin-top: 15px;">
            <div class="member-edit-permission">
              <div>
                <div class="permission-maintitle">検索</div>
                <div class="permission-subtitle">インフルエンサー・投稿の検索と分析画面へのアクセス権限を付与します</div>
              </div>
              <div class="flex-space"></div>
              <div class="permission-title">
                <el-tooltip content="検索のアクセス権限はオフにできません">
                  <el-switch v-model="member.permitted_list.search.access" disabled @change="editHandler()"></el-switch>
                </el-tooltip>
              </div>
            </div>
            <div class="member-edit-permission">
              <div>
                <div class="permission-maintitle">リスト</div>
                <div class="permission-subtitle">リストのアクセス・編集権限を付与します</div>
              </div>
              <div class="flex-space"></div>
              <div class="permission-title left">
                <div class="permission-title-desc">アクセス権</div>
                <el-switch v-model="member.permitted_list.list.access" :disabled="member.admin_member" @change="editHandler('list', 'access')"></el-switch>
              </div>
              <div class="permission-title">
                <div class="permission-title-desc">編集権</div>
                <el-switch v-model="member.permitted_list.list.edit" :disabled="member.admin_member" @change="editHandler('list', 'edit')"></el-switch>
              </div>
            </div>
            <div class="member-edit-permission">
              <div>
                <div class="permission-maintitle">ノート・カスタマイズタグ</div>
                <div class="permission-subtitle">ノート・カスタマイズタグのアクセス・編集権限を付与します</div>
              </div>
              <div class="flex-space"></div>
              <div class="permission-title left">
                <div class="permission-title-desc">アクセス権</div>
                <el-switch v-model="member.permitted_list.note.access" :disabled="member.admin_member" @change="editHandler('note', 'access')"></el-switch>
              </div>
              <div class="permission-title">
                <div class="permission-title-desc">編集権</div>
                <el-switch v-model="member.permitted_list.note.edit" :disabled="member.admin_member" @change="editHandler('note', 'edit')"></el-switch>
              </div>
            </div>
            <div class="member-edit-permission">
              <div>
                <div class="permission-maintitle">パーソナルデータ</div>
                <div class="permission-subtitle">パーソナルデータのアクセス・編集権限を付与します</div>
              </div>
              <div class="flex-space"></div>
              <div class="permission-title left">
                <div class="permission-title-desc">アクセス権</div>
                <el-switch v-model="member.permitted_list.personal_data.access" :disabled="member.admin_member" @change="editHandler('personal_data', 'access')"></el-switch>
              </div>
              <div class="permission-title">
                <div class="permission-title-desc">編集権</div>
                <el-switch v-model="member.permitted_list.personal_data.edit" :disabled="member.admin_member" @change="editHandler('personal_data', 'edit')"></el-switch>
              </div>
            </div>
            <div class="member-edit-permission">
              <div>
                <div class="permission-maintitle">レポート</div>
                <div class="permission-subtitle">レポート画面へのアクセス、レポートの作成・編集・削除権限を付与します</div>
              </div>
              <div class="flex-space"></div>
              <div class="permission-title"><el-switch v-model="member.permitted_list.report.access" :disabled="member.admin_member" @change="editHandler()"></el-switch></div>
            </div>
            <div class="member-edit-permission">
              <div>
                <div class="permission-maintitle">ダイレクトメッセージ</div>
                <div class="permission-subtitle">
                  以下の権限を付与します<br />
                  <span class="permission-subtitle-li">・ダイレクトメッセージの閲覧・送受信<br /></span>
                  <span class="permission-subtitle-li">・メッセージテンプレートの作成・編集・削除<br /></span>
                  <span class="permission-subtitle-li">・Instagramアカウントの連携・解除</span>
                </div>
              </div>
              <div class="flex-space"></div>
              <div class="permission-title"><el-switch v-model="member.permitted_list.message.access" :disabled="member.admin_member" @change="editHandler()"></el-switch></div>
            </div>
            <div class="member-edit-permission">
              <div>
                <div class="permission-maintitle">リクエスト</div>
                <div class="permission-subtitle">リクエスト画面へのアクセス、リクエスト実行権限を付与します</div>
              </div>
              <div class="flex-space"></div>
              <div class="permission-title"><el-switch v-model="member.permitted_list.request.access" :disabled="member.admin_member" @change="editHandler()"></el-switch></div>
            </div>
            <div class="member-edit-permission">
              <div>
                <div class="permission-maintitle">インポート</div>
                <div class="permission-subtitle">インポート画面へのアクセス、インポート実行・削除権限を付与します</div>
              </div>
              <div class="flex-space"></div>
              <div class="permission-title"><el-switch v-model="member.permitted_list.import.access" :disabled="member.admin_member" @change="editHandler()"></el-switch></div>
            </div>
            <div class="member-edit-permission">
              <div>
                <div class="permission-maintitle">エクスポート</div>
                <div class="permission-subtitle">リスト・レポートのエクスポート実行権限を付与します<br>※各アクセス権が合わせて必要です</div>
              </div>
              <div class="flex-space"></div>
              <div class="permission-title"><el-switch v-model="member.permitted_list.export.access" :disabled="member.admin_member" @change="editHandler()"></el-switch></div>
            </div>
            <div class="member-edit-permission bottom">
              <div>
                <div class="permission-maintitle">会社情報・請求情報</div>
                <div class="permission-subtitle">
                  以下の権限を付与します<br />
                  <span class="permission-subtitle-li">・ご利用プラン詳細の閲覧<br /></span>
                  <span class="permission-subtitle-li">・会社情報の編集<br /></span>
                  <span class="permission-subtitle-li">・メンバーの追加・権限編集・削除<br /></span>
                  <span class="permission-subtitle-li">・請求情報の編集、請求履歴の閲覧</span>
                </div>
              </div>
              <div class="flex-space"></div>
              <div class="permission-title">
                <el-tooltip content="会社情報・請求情報の権限は管理者のみに付与されます">
                  <span>
                    <el-switch v-model="member.permitted_list.company_setting.access" disabled @change="editHandler()"></el-switch>
                  </span>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-space"></div>
        <div class="member-edit-button-area">
          <el-button size="small" @click="closeMemberModal()">キャンセル</el-button>
          <el-button type="primary" size="small" @click="saveMember()">
            <div class="flex-row">
              設定を保存
              <div class="loader--mini" v-show="save_loading"></div>
            </div>
          </el-button>
        </div>
      </div>
    </div>
    <div class="overlay" :class="[member_modal ? 'overlay open' : 'overlay']" @click="closeMemberModal()"></div>

    <el-dialog title="イメージ画像の変更" :visible.sync="img_upload" width="420px" top="20vh">
      <el-upload drag :on-change="imgAdd" :auto-upload="false" list-type="picture" :limit="1" :file-list="fileList" action="">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          画像をドロップ
          <em>もしくは選択してアップロードしてください</em>
        </div>
        <div class="el-upload__tip" slot="tip">推奨ファイル:500kb以下のjpg/png形式</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(img_upload = false), (fileList = [])">キャンセル</el-button>
        <el-button type="primary" @click="memberImgUpload()" :disabled="file == ''">
          <div class="flex-row">
            変更
            <div class="loader--mini" v-show="img_loading"></div>
          </div>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UserTokenSiteName from "@/components/oem/UserTokenSiteInfo.vue";
import { handleApiResponse, ERROR_MESSAGES } from "@/components/common/responseHelper";
import { getImageUploadWarning } from "@/components/common/imageUploadHelper";
const root = process.env.VUE_APP_API;
const ImgUploadAPI = root + "/api/auth/img_upload";
const loadMemberDetailAPI = root + "/api/member/load_member_detail";
const saveMemberAPI = root + "/api/member/save_member";
const deleteMemberAPI = root + "/api/member/delete_member";
import memberInput from "./member_input";

export default {
  name: "memberEdit",
  props: ["person_id", "member_modal", "index"],
  components: {
    UserTokenSiteName,
    memberInput,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      loading: true,
      save_loading: false,
      edit: false,
      member: [],
      img_upload: false,
      img_loading: false,
      file: "",
      fileList: [],
      permission_member: [],
      permission_admin: [],
      siteName: "REECH DATABASE",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  mounted() {},
  methods: {
    loadMember() {
      this.loading = true;
      this.member = [];
      this.axios
        .get(loadMemberDetailAPI, {
          params: {
            token: this.token,
            person_id: this.person_id,
          },
        })
        .then((response) => {
          this.member = response.data.member;
          this.permission_admin = response.data.permission_admin;
          this.permission_member = response.data.permission_member;
          if (response.data.member.permitted_list == null) {
            this.member.permitted_list = this.permission_member;
          }
          this.edit = false;
          this.loading = false;
        })
        .catch(() => {
          this.edit = false;
          this.loading = false;
        });
    },
    saveMember() {
      this.save_loading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("member", JSON.stringify(this.member));
      params.append("person_id", this.person_id);
      this.axios
        .post(saveMemberAPI, params)
        .then(() => {
          this.$emit("loadMember");
          this.save_loading = false;
          this.$emit("update:member_modal", false);
          this.$store.dispatch("getUserData", { token: this.token, user_token: this.user_token });
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "メンバー情報を編集しました",
          });
        })
        .catch(() => {
          this.save_loading = false;
        });
    },
    deleteMember() {
      this.$confirm("削除されたメンバーは" + this.siteName + " にアクセスできなくなります。メンバーを削除してもよろしいですか？<br>この操作は取り消せません。", "メンバー削除", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "削除",
        cancelButtonText: "キャンセル",
        confirmButtonClass: "danger",
        type: "danger",
      })
        .then(() => {
          var person_name = this.member.person_name;
          var params = new URLSearchParams();
          params.append("person_id", this.member.person_id);
          params.append("token", this.token);
          params.append("user_token", this.member.user_token);
          this.axios.post(deleteMemberAPI, params).then(() => {
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: "「" + person_name + "」を削除しました",
            });
            this.$emit("loadMember");
            this.$emit("update:member_modal", false);
          });
        })
        .catch(() => {});
    },
    switchAdmin() {
      if (this.member.admin_member == true) {
        this.member.permitted_list = this.permission_admin;
      } else if (this.member.admin_member == false) {
        this.member.permitted_list = this.permission_member;
      }
    },
    editHandler(item, type) {
      this.edit = true;
      if (item && type) {
        var switch_on = this.member.permitted_list[item][type];
        if (type == "access" && switch_on == false) {
          this.member.permitted_list[item].edit = false;
        } else if (type == "edit" && switch_on == true) {
          this.member.permitted_list[item].access = true;
        }
      }
    },
    closeMemberModal() {
      if (this.edit == true) {
        this.$confirm("編集が保存されていません。編集画面を閉じてよろしいですか？", "メンバー編集を閉じる", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "閉じる",
          cancelButtonText: "キャンセル",
          type: "warning",
        })
          .then(() => {
            this.$emit("update:member_modal", false);
          })
          .catch(() => {});
      } else {
        this.$emit("update:member_modal", false);
      }
    },
    imgAdd(file, fileList) {
      const result = getImageUploadWarning(file);
      if (result.message) {
        this.$message({
          type: result.allowUpload ? "warning" : "error",
          offset: 7,
          showClose: true,
          message: result.message,
        });
      }
      if (!result.allowUpload) {
        this.file = "";
        this.fileList = [];
        return;
      }
      this.file = file;
      this.fileList = fileList;
    },
    memberImgUpload() {
      if (!this.file || !this.file.raw) {
        return;
      }
      this.img_loading = true;
      var formData = new FormData();
      formData.append("file", this.file.raw);
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      formData.append("type", "member");
      formData.append("person_id", this.member.person_id);
      formData.append("token", this.token);
      this.axios
        .post(ImgUploadAPI, formData, config)
        .then((response) => {
          if (handleApiResponse(response)) {
            this.$message({
              message: ERROR_MESSAGES.IMAGE_UPLOAD,
              type: "error",
            });
            return;
          }
          this.member.img_url = response.data.img_url;
          this.file = "";
          this.fileList = [];
          this.img_upload = false;
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "イメージを変更しました",
          });
          this.$emit("loadMember");
        })
        .catch(() => {
          this.$message({
            message: ERROR_MESSAGES.IMAGE_UPLOAD,
            type: "error",
          });
        })
        .finally(() => {
          this.img_loading = false;
        });
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
  },
  filters: {
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
  watch: {
    member_modal() {
      if (this.member_modal == true) {
        this.loadMember();
      }
    },
  },
};
</script>
